const Divider = ({ noMargin }) => {
  return <div className={`separator${noMargin ? " no-margin" : ""}`} />;
};

export default Divider;
